
import {
  defineComponent, onBeforeMount, reactive, watch,
} from 'vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import Icone from '@/core/components/Icone.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import { IListaPaginadaMetaData } from '@/core/models/Consulta/IListaPaginada';
import { ECustomRenderRow, IColumn } from '@/core/models/AntDesign/IColumn';
import { IPagination } from '@/core/models/AntDesign/IPagination';
import { ETipoPermissao } from '@/models/Enumeradores/MeuSistema/Usuarios/ETipoPermissao';
import { EVinculoEmpresa } from '@/core/models/Enumeradores/EEVinculoEmpresa';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import storeSistema from '@/store/storeSistema';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import { useGradeBase } from '@/core/composables/GradeBase';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import Card from '@/core/components/Tela/Card.vue';
import { ETipoTituloFinanceiro } from '@/models/Enumeradores/Financeiro/ETipoTituloFinanceiro';
import { EStatusTituloFinanceiro } from '@/models/Enumeradores/Financeiro/EStatusTituloFinanceiro';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import SelecionarTipoRelatorioBalancete from '@/components/Relatorios/Financeiro/SelecionarTipoRelatorioBalancete.vue';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import ServicoRelatorioFinanceiro from '@/servicos/Relatorios/ServicoRelatoriosFinanceiros';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { useTituloFinanceiroBase } from '@/composables/Financeiro/TituloFinanceiroBase';
import TotalizadorDecorado from '@/core/components/Tela/TotalizadorDecorado.vue';
import { ETipoRelatorioBalancete } from '@/models/Enumeradores/Relatorios/ETipoRelatorioBalancete';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import { ISalvamentoAutomatico } from '@/models/Entidades/MeuSistema/ISalvamentoAutomatico';
import SelecionarCategoriaPlanoConta from '@/components/Cadastros/PlanosContas/SelecionarCategoriaPlanoConta.vue';
import { IFiltrosRelatorioBalancete } from '@/models/Relatorios/Financeiro/Balancete/IFiltrosRelatorioBalancete';
import { IDadosRelatorioBalancete, IDadosRelatorioBalanceteAgrupador, IDadosRelatorioBalanceteItem } from '@/models/Relatorios/Financeiro/Balancete/IDadosRelatorioBalancete';
import SelecionarConta from '@/components/Cadastros/Financeiro/SelecionarConta.vue';
import RecebimentoMercadoriaDetalhePagamento from '@/components/Compras/RecebimentosMercadorias/RecebimentoMercadoriaDetalhePagamento.vue';

export default defineComponent({
  name: 'RelatorioBalancete',
  components: {
    Icone,
    Card,
    MensagemSemDados,
    TituloPadrao,
    PreviewPdf,
    SelecionarTipoRelatorioBalancete,
    SelecionarDataInicialFinal,
    SelecionarCategoriaPlanoConta,
    TotalizadorDecorado,
    SelecionarConta,
  },
  setup(props) {
    const servicoSistema = new ServicoSistema();
    const servicoRelatorioFinanceiro = new ServicoRelatorioFinanceiro();
    const {
      telaBase, obterPermissoes, preencherEmpresasDisponiveis, verificaConceitoParaApresentarEmpresas, apresentarMensagemErro,
      defineEmpresasSelecionadasComPermissao, filtrarPermissaoDadosUsuarioMultiEmpresas, apresentarMensagemAlerta,
      adicionarAtalho, removerAtalho, preencherDadosRota,
    } = useTelaBase();

    const { gradeBase } = useGradeBase();
    const { obterClasseStatus } = useTituloFinanceiroBase(props);

    const state = reactive({
      dataInicial: '01/01/2001',
      dataFinal: '10/01/2001',
      filtros: {} as IFiltrosRelatorioBalancete,
      filtrosUtilizados: {} as IFiltrosRelatorioBalancete,
      resultado: {} as IDadosRelatorioBalancete,
      itens: [] as IDadosRelatorioBalanceteItem[],
      grupos: [] as IDadosRelatorioBalanceteAgrupador[],
      colunasInternas: [] as IColumn[],
      paginacao: {} as IPagination,
      paginacaoApi: { totalRegistros: 0, paginaAtual: 1 } as IListaPaginadaMetaData,
      timerRegistros: 0,
      totalRegistrosComMascara: '100',
      arquivosPdf: [] as IArquivoPdf[],
      mostrarFiltros: 0,
      mostrarFiltrosInteligentes: 1,
      mostrarTotalizadores: 0,
      mostrarTitulos: false,
      cacheAutomatico: {} as ISalvamentoAutomatico,
    });

    telaBase.apresentarEmpresas = false;
    function preencherColunas() {
      if (storeSistema.state.layoutMobile) {
        gradeBase.colunas = [
          {
            title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false,
          },
          {
            title: 'Item', dataIndex: 'item', key: 'Item', position: 2, visible: true,
          },
        ];
      } else if (state.filtrosUtilizados.tipo === ETipoRelatorioBalancete.Geral) {
        gradeBase.colunas = [
          {
            title: 'Número', dataIndex: 'numeroCategoria', key: 'NumeroCategoria', position: 1, visible: true, align: 'left', width: 200,
          },
          {
            title: 'Categoria', dataIndex: 'nomeCategoria', key: 'NomeCategoria', position: 2, visible: true,
          },
          {
            title: 'R$ Crédito', dataIndex: 'credito', key: 'Credito', position: 3, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'R$ Débito', dataIndex: 'debito', key: 'Debito', position: 4, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'R$ Saldo', dataIndex: 'saldo', key: 'Saldo', position: 5, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
        ];
      } else if (state.filtrosUtilizados.tipo === ETipoRelatorioBalancete.Detalhado) {
        gradeBase.colunas = [
          {
            title: 'Número', dataIndex: 'numeroCategoria', key: 'NumeroCategoria', position: 2, visible: true, align: 'left', width: 200,
          },
          {
            title: 'Categoria', dataIndex: 'nomeCategoria', key: 'NomeCategoria', position: 3, visible: true,
          },
          {
            title: 'R$ Crédito', dataIndex: 'totalCreditos', key: 'TotalCredito', position: 5, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'R$ Débito', dataIndex: 'totalDebitos', key: 'TotalDebito', position: 6, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'R$ Saldo', dataIndex: 'saldoTotal', key: 'SaldoTotal', position: 6, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
        ];
        state.colunasInternas = [
          {
            title: 'Data', dataIndex: 'dataFormatada', key: 'DataFormatada', position: 1, visible: true, align: 'center', width: 200,
          },
          {
            title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 4, visible: true,
          },
          {
            title: 'R$ Crédito', dataIndex: 'credito', key: 'Credito', position: 5, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'R$ Débito', dataIndex: 'debito', key: 'Debito', position: 6, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'R$ Saldo', dataIndex: 'saldo', key: 'Saldo', position: 6, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
        ];
      } else {
        gradeBase.colunas = [
          {
            title: 'Data', dataIndex: 'dataFormatada', key: 'DataFormatada', position: 1, visible: true, align: 'center', width: 200,
          },
          {
            title: 'Número', dataIndex: 'numeroCategoria', key: 'NumeroCategoria', position: 2, visible: true, align: 'left', width: 200,
          },
          {
            title: 'Categoria', dataIndex: 'nomeCategoria', key: 'NomeCategoria', position: 3, visible: true,
          },
          {
            title: 'R$ Crédito', dataIndex: 'credito', key: 'Credito', position: 4, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'R$ Débito', dataIndex: 'debito', key: 'Debito', position: 5, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'R$ Saldo', dataIndex: 'saldo', key: 'Saldo', position: 6, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
        ];
      }
    }

    function obterIdentificadorCache(): string {
      return `RELATORIO_BALANCETE_${storeSistema.getters.codigoUsuarioAutenticado()}`;
    }

    function salvarCache() {
      const identificador = obterIdentificadorCache();
      state.cacheAutomatico.data = UtilitarioData.obterDataAtual();
      state.cacheAutomatico.codigoEmpresa = state.filtros.empresa;
      state.cacheAutomatico.codigoUsuario = storeSistema.getters.codigoUsuarioAutenticado();
      state.cacheAutomatico.identificador = telaBase.identificadorRecurso;
      state.cacheAutomatico.dados = JSON.stringify(state.filtros);
      servicoSistema.salvamentoAutomaticoLocalStorage(`${identificador}`, state.cacheAutomatico);
    }

    async function recuperarCache() {
      const cacheRestaurado = await servicoSistema.obterSalvamentoAutomaticoLocalStorage(obterIdentificadorCache());
      if (UtilitarioGeral.valorValido(cacheRestaurado)) {
        const cache = JSON.parse(cacheRestaurado.dados);
        state.filtros = cache;
        state.dataInicial = cache.dataInicial;
        state.dataFinal = cache.dataFinal;
        state.mostrarFiltros = 1;
        state.mostrarFiltrosInteligentes = 0;
      }
    }

    async function buscarRelatorio() {
      telaBase.carregando = true;
      state.filtros.dataInicial = state.dataInicial;
      state.filtros.dataFinal = state.dataFinal;
      state.filtros.numeroPagina = state.paginacao.current;
      state.filtros.qtdRegistrosPagina = state.paginacao.pageSize;
      state.filtros.qtdTotalRegistros = state.paginacao.total;
      state.resultado = await servicoRelatorioFinanceiro.obterBalancete(state.filtros);
      state.filtrosUtilizados = UtilitarioGeral.clonarObjeto(state.filtros);
      salvarCache();
      preencherColunas();
      state.mostrarTitulos = true;
      state.itens = state.resultado.itens.dados;
      state.grupos = state.resultado.grupos;

      state.paginacaoApi = state.resultado.itens.metaData;
      state.mostrarFiltros = 0;
      state.mostrarFiltrosInteligentes = 0;
      state.mostrarTotalizadores = 1;
      telaBase.carregando = false;
    }

    async function alterarQuantidadeRegistroTotal(valor: any) {
      clearTimeout(state.timerRegistros);
      let totalRegistros = 100;
      state.timerRegistros = setTimeout(async () => {
        if (UtilitarioGeral.valorValido(valor)) {
          const limiteRegistros = UtilitarioMascara.removerMascaraNumero(valor);
          if (limiteRegistros > 0) {
            totalRegistros = limiteRegistros;
          }
        }
        state.paginacao.total = totalRegistros;
        state.totalRegistrosComMascara = UtilitarioMascara.mascararNumeroInteiro(totalRegistros);
        await buscarRelatorio();
      }, 600);
    }

    async function onPageChange(current: number, pageSize: number) {
      state.paginacao.current = current;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    async function onShowSizeChange(current: number, pageSize: number) {
      state.paginacao.current = 1;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(state.filtros.empresa);
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
      await buscarRelatorio();
    }

    function usarFiltroInteligente(filtro: number) {
      switch (filtro) {
        case 1:
          state.filtros.tipo = ETipoRelatorioBalancete.Geral;
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.filtros.categorias = [];
          break;
        case 2:
          state.filtros.tipo = ETipoRelatorioBalancete.Diario;
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.filtros.categorias = [];
          break;
        case 3:
          state.filtros.tipo = ETipoRelatorioBalancete.Geral;
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataInicial = UtilitarioData.adicionarMesNaData(state.dataInicial, 1);
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.dataFinal = UtilitarioData.adicionarMesNaData(state.dataFinal, 1);
          state.filtros.categorias = [];
          break;
        default:
          state.filtros.tipo = ETipoRelatorioBalancete.Diario;
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataInicial = UtilitarioData.adicionarMesNaData(state.dataInicial, 1);
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.dataFinal = UtilitarioData.adicionarMesNaData(state.dataFinal, 1);
          state.filtros.categorias = [];
          break;
      }
      buscarRelatorio();
    }

    async function imprimir(tipoArquivoRelatorio:ETipoArquivo) {
      telaBase.carregando = true;
      if (!UtilitarioGeral.validaLista(state.itens)) {
        await buscarRelatorio();
      }
      const retornoRelatorio = await servicoRelatorioFinanceiro.obterArquivoBalancete(tipoArquivoRelatorio, state.filtrosUtilizados);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    function limparFiltros() {
      state.filtros = {} as IFiltrosRelatorioBalancete;
      state.filtros.empresa = storeSistema.getters.codigoEmpresaOperacao();
      state.filtros.tipo = ETipoRelatorioBalancete.Geral;
      state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
      state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
      state.filtros.categorias = [] as number[];
    }

    watch(() => storeSistema.state.layoutMobile, () => {
      preencherColunas();
    });

    onBeforeMount(async () => {
      preencherDadosRota();
      await obterPermissoes(ETipoPermissao.Dados);
      await preencherEmpresasDisponiveis();
      await defineEmpresasSelecionadasComPermissao();
      verificaConceitoParaApresentarEmpresas();
      recuperarCache();
      preencherColunas();
      limparFiltros();
      state.paginacao.total = 100;
      state.paginacao.showSizeChanger = true;
      state.paginacao.pageSize = 100;
      state.paginacao.current = 1;
      state.paginacao.pageSizeOptions = ['10', '50', '100', '500', '1000'];
    });

    return {
      state,
      props,
      window,
      ETipoTituloFinanceiro,
      EStatusTituloFinanceiro,
      EVinculoEmpresa,
      ETipoArquivo,
      ECustomRenderRow,
      ETipoRelatorioBalancete,
      UtilitarioMascara,
      UtilitarioData,
      UtilitarioDispositivo,
      storeSistema,
      telaBase,
      gradeBase,
      preencherColunas,
      onPageChange,
      onShowSizeChange,
      alterarQuantidadeRegistroTotal,
      adicionarAtalho,
      removerAtalho,
      atualizarSelecaoEmpresas,
      obterClasseStatus,
      buscarRelatorio,
      usarFiltroInteligente,
      imprimir,
    };
  },
});
